import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Signin from './forms/signin'
import Confirm from './forms/confirm'
import Signup from './forms/signup'
import Registration from './registration'

function RegistrationPlugin({league, type, token, payment_params}) {
  const [player, setPlayer] = useState({})
  const [step, setStep] = useState('signin')
  const [prevStep, setPrevStep] = useState()
  const isSignin = step == 'signin'
  const isConfirm = step == 'confirm'
  const isSignup = step == 'signup'
  const isRegistration = step == 'registration'
  
  const onSignedIn = (playerData) => {
    setPlayer(playerData)
    setStep('confirm')
    setPrevStep('signin')
  }

  const onSignedUp = (playerData) => {
    setPlayer(playerData)
    setStep('confirm')
    setPrevStep('signup')
  }

  const onConfirmed = (playerData) => {
    setPlayer({...player, ...playerData})
    setStep('registration')
  }

  const onClickSignup = () => {
    setPlayer(null)
    setStep('signup')
  }

  return <div>
    { isSignin &&
      <Signin
        token={token}
        league={league}
        defaults={player}
        onSignup={onClickSignup}
        onSuccess={onSignedIn}
      />
    }
    { isSignup && 
      <Signup 
        token={token}
        type={type}
        league={league}
        defaults={player}
        onBack={() => setStep('signin')}
        onComplete={onSignedUp}
      />
    }
    { isConfirm && 
      <Confirm 
        token={token}
        league={league}
        player={player}
        onBack={() => setStep(prevStep)}
        onConfirmed={onConfirmed}
      />
    }
    { isRegistration && 
      <Registration
        token={token}
        league={league}
        type={type}
        player={player}
        paymentParams={payment_params}
      />
    }
  </div>
}

RegistrationPlugin.propTypes = {
  league: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  payment_params: PropTypes.object.isRequired,
}

export default RegistrationPlugin
